module.exports = postalOperators;